import React from 'react';

import {
  Typography,
  Grid,
  makeStyles,
  Chip,
  NoResults,
  UnpublishedIcon,
  Stack,
  PrivacyTipIcon,
  Divider,
} from '@gogame/components';

import { History } from './History';
import { PlayersInformation } from './PlayersInformation';

const useStyles = makeStyles((theme) => ({
  fullSize: {
    height: '100%',
    width: '100%',
  },
  emptyStateTypography: {
    color: theme.palette.text.secondary,
  },
  divider: {
    padding: '8px 0',
    marginLeft: '-16px',
  },
  message: {
    marginBottom: '8px',
  },
  scrollContent: {
    maxHeight: 'calc(100vh - 238px)',
    overflowY: 'scroll',
  },
}));

const Results = ({ data, isLoading, isEmpty }) => {
  const classes = useStyles();
  const isShowInitState = !data && !isLoading;

  const isShowMessage = !!data?.message;
  const isShowResults = !!data?.playerInformation?.regActionId;
  const isShowNoResults = !isShowResults && !isLoading;

  return (
    <Grid container className={`${isShowNoResults ? classes.fullSize : ''}`}>
      {isShowNoResults && (
        <Grid item container alignItems={'center'} justifyContent={'center'}>
          <NoResults
            inited={!isShowInitState}
            filtered={isEmpty}
            notInitedLabel={'Press the "Apply" Button to view results'}
            noMatchesLabel={'User not found'}
          />
        </Grid>
      )}

      {isShowMessage && (
        <Grid item xs={12} className={classes.message}>
          <Typography variant={'subtitle2'}>{data?.message}</Typography>
        </Grid>
      )}

      {isShowResults ? (
        <React.Fragment>
          <Grid item container xs={12} className={classes.message}>
            <Stack
              direction={'row'}
              spacing={1}
              flexWrap={'wrap'}
              alignItems={'center'}
            >
              <Typography variant={'subtitle1'} sx={{ fontWeight: 500 }}>
                Player #{data?.playerInformation?.regActionId}
              </Typography>
              {data?.eventInformation?.length === 1 &&
              !data?.eventInformation?.[0]?.isEventCompleted ? (
                <Chip
                  size={'small'}
                  icon={<UnpublishedIcon />}
                  label={'Event not completed'}
                />
              ) : null}
              {data?.playerInformation?.isFraud ? (
                <Chip
                  size={'small'}
                  icon={<PrivacyTipIcon />}
                  label={'Fraud'}
                />
              ) : null}
            </Stack>
          </Grid>
          <Grid item xs={12} className={classes.divider} style={{padding: '8px 0 0 0'}}>
            <Divider />
          </Grid>
          <Grid container className={classes.scrollContent}>
            <PlayersInformation data={data?.playerInformation} />
            <Grid item xs={12} className={classes.divider}>
              <Divider />
            </Grid>
            <History data={data} />
          </Grid>
        </React.Fragment>
      ) : null}
    </Grid>
  );
};

export default Results;
